import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as actions from '../actions/azure-blob-storage.actions';
import { AzureBlobStorage } from '../azure-blob-storage.model';
import { AzureBlobStorageActions, AzureBlobStorageActionTypes } from '../actions/azure-blob-storage.actions';
import { BlobClient } from '@azure/storage-blob';

export interface State extends EntityState<AzureBlobStorage> {
  isLoaded: boolean;
  isLoading: boolean;
  blob: BlobClient;
  action: string;
}

export const adapter: EntityAdapter<AzureBlobStorage> = createEntityAdapter<AzureBlobStorage>();

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  blob: null,
  action: ''
});

export interface SASTokenState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: string;
}

const initialDetailsState: SASTokenState = {
  isLoading: false,
  isLoaded: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: AzureBlobStorageActions
): State {
  switch (action.type) {
    case AzureBlobStorageActionTypes.GetDownLoadAzureBlobStorages: {

      return {...state, isLoaded: false, isLoading: true};
    }

    case AzureBlobStorageActionTypes.DownloadAzureBlobStoragesSuccess: {
      return {...state, isLoaded: true, isLoading: false, blob: action.payload.azureBlobStorages, action: action.payload.action};
    }

    case AzureBlobStorageActionTypes.GetUploadAzureBlobStorages: {
      return {...state, isLoaded: false, isLoading: true};
    }

    case AzureBlobStorageActionTypes.UploadAzureBlobStoragesSuccess: {
      return {...state, isLoaded: true, isLoading: false, blob: action.payload.azureBlobStorages, action: action.payload.action};
    }

    default: {
      return state;
    }
  }
}

export function tokenReducer(state: SASTokenState = initialDetailsState, action: AzureBlobStorageActions): SASTokenState {

  switch (action.type) {
    case AzureBlobStorageActionTypes.GetAzureBlobStoragesSASToken:
      return {...state, isLoading: true, isLoaded: false, entities: state.entities};
    case AzureBlobStorageActionTypes.AddAzureBlobStoragesSASToken:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const getAzureBlobStorageSASTokenState = (state: SASTokenState) => state;
